module.exports = __webpack_public_path__ + "img/abbvie.3d134357.png";